import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IFetchZonesResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchZones(): Promise<IFetchZonesResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/cms/zones`,
    {
      validator: serverResponse,
      searchParams: {
        brand: "NJU",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(result.value);
}
